import { CIcon } from '~/icons/types'

export const ciChevronLeft: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d: 'M15.75 19.5 8.25 12l7.5-7.5',
      strokeWidth: '3',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      fill: 'none',
      stroke: 'currentColor'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'chevron-left',
  type: 'solid',
  fill: 'none'
}
